// VideoIntro.js
import React from 'react';
import { Container, Row, Col, Button,Card } from 'react-bootstrap';
import Markdown from './Markdown';

// CHANGED / NEW — add these near the top with other consts

// NEW — add alongside iframeStyle etc.
const imageStyle = {
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover'
};

const iframeStyleDefault = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  width: '100vw',
  height: '56.25vw',     // 16:9 based on width
  minWidth: '177.78vh',  // 16:9 based on height
  minHeight: '100%',
  transform: 'translate(-50%, -50%)',
  border: 0
};

// CHANGED
const VideoIntro = ({ 
    useImageUnderlay = false,
    yt_url = `https://www.youtube.com/embed/gqGCei_DePA?autoplay=1&mute=1&loop=1&controls=0&playlist=gqGCei_DePA&modestbranding=1&playsinline=1&rel=0`,
    img_path = '/ai_banner.png',
    hero_button_label = 'courses',
    hero_button_link='http://google.com',
    hero_area_text = "sign up\n\n\n\n\n\n\n\n",
    call_to_action_title = "LEARN \nAI\n ART\n",
    iframeStyle

}) => {  // NEW: destructured prop with default

const sectionStyle = {
  position: 'relative',
  height: '85vh',
  overflow: 'hidden'
};

const videoWrapStyle = {
  position: 'absolute',
  inset: 0,
  overflow: 'hidden'
};

  const overlayStyle = {
    position: 'absolute',
    inset: 0,
    backgroundColor: 'rgba(0,0,0,0.15)'
  };



// contentStyle: minHeight -> height
const contentStyle = {
  position: 'relative',
  zIndex: 1,
  height: '100%',
  display: 'flex',
  alignItems: 'stretch'
};


  const verticalTextStyle = {
    writingMode: 'vertical-rl',
    textOrientation: 'upright',
    fontWeight: 800,
    lineHeight: 1,
    whiteSpace: 'pre-line',
    fontSize: 'clamp(2rem, 8vw, 8rem)'
  };

  return (
    <section style={sectionStyle}>
      {/* Underlay video */}
      <div style={videoWrapStyle}>
            {useImageUnderlay ? (
                <img src={img_path} alt="" style={imageStyle} />
            ) : (
                <iframe
                title="Video Intro Background"
                src={yt_url}
                style={iframeStyle}
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                />
            )}
      </div>

      {/* Tint overlay */}
      <div style={overlayStyle} />

      {/* Overlay content */}
      <Container fluid style={contentStyle}>
        <Row className="flex-fill h-100">

        <Col
        md={4}
        className="d-none d-md-flex justify-content-center align-items-end px-4 mb-4"
        >
        <div
            className="text-light text-left"
            style={{
            fontWeight: 800,
            fontSize: 'clamp(2rem, 8vw, 8rem)',
            whiteSpace: 'pre-line',
            lineHeight: 1
            }}
        >
            {call_to_action_title}
        </div>
        </Col>


          {/* Middle: intentionally empty */}
          <Col md={5} className="d-none d-md-block" />

          {/* Right: desktop button anchored bottom-right */}
            <Col
            md={3}
            className="d-none d-md-flex align-items-end justify-content-start p-4"
            >
        <Card className="w-100 shadow">
          <Card.Body className="d-flex flex-column align-items-start">
            <Card.Text style={{ fontSize: '1.1rem' }}> 
               <Markdown md={hero_area_text} />
            </Card.Text>
            <Button
              variant="danger"
              size="lg"
              href={hero_button_link}
              className="mt-3"
              style={{
                fontSize: '1.75rem',
                padding: '1rem 2.5rem',
                backgroundColor: 'darkred',
                borderColor: 'black',
              }}
            >
              {hero_button_label}
            </Button>
          </Card.Body>
        </Card>

            </Col>

          {/* Mobile button: centered at bottom */}
          <Col xs={12} className="d-flex d-md-none align-items-end justify-content-center p-3">
            <Button
                variant="danger"
                size="lg"
                href="#video-intro-bottom"
                className="mb-0"
                style={{ fontSize: '1.75rem', 
                    padding: '1rem 2.5rem', 
                    backgroundColor: 'darkred',
                    borderColor: 'black',
                }}
            >
              {hero_button_label}
            </Button>
          </Col>
        </Row>
      </Container>

      {/* Hidden anchor at the very bottom to scroll to */}
      <div id="video-intro-bottom" style={{ position: 'absolute', bottom: 0, left: 0 }} />
    </section>
  );
};

export default VideoIntro;
